export const APP_ROUTES = {
  home: "/",
  login: "/login",
  notifications: "/notifications",
  notificationCampaigns: "/notification-campaigns",
  driverMessages: "/driver-messages",
  finance: "/financial-management",
  financialWithdrawals: "/financial-management/withdrawal",
  financialTransactions: "/financial-management/transactions",
  financialReports: "/financial-management/financial-report",
  financialBolReport:
    "/financial-management/financial-report/bol-financial-report",
  bols: "/bol-management",
  bol: (bolId: string | undefined) => `/bol-management/${bolId}`,
  hagbarBolPlayground: "/bol-management/hagbar-playground",
  hagbarBolPlaygroundDetail: (bolId: string | undefined) =>
    `/bol-management/hagbar-playground/${bolId}`,
  createBol: "/bol-management/create-bol",
  createNewBol: "/bol-management/create-new-bol",
  settings: "/settings",
  users: "/settings/users",
  otherConfigs: "/other-configs",
  mobileConfig: "/mobile-config",
  pricingSettings: "/pricing-settings",
  bolRequestAvailability: "/bol-request-availability",
  issuingSystemSettings: "/issuing-system-settings",
  basicInformation: "/basic-information",
  mobileBanners: "/mobile-banners",
  contracts: "/contract-management",
  bolIssuingContracts: "/contract-management/bol-issuing-company",
  bolIssuingContract: (contractId: string) =>
    `/contract-management/bol-issuing-company/${contractId}`,
  cargoOwnerContracts: "/contract-management/cargo-owner",
  cargoOwnerContract: (contractId: string | undefined) =>
    `/contract-management/cargo-owner/${contractId}`,
  cargoOwnerContractDetails: (contractId: string | undefined) =>
    `/contract-management/cargo-owner/${contractId}/contract`,
  cargoOwners: "/cargo-owner-management",
  cargoOwner: (cargoOwnerId: string | undefined) =>
    `/cargo-owner-management/${cargoOwnerId}`,
  cargoOwnerBranch: (cargoOwnerId: string, branchId: string) =>
    `/cargo-owner-management/${cargoOwnerId}/${branchId}`,
  drivers: "/driver-management",
  driverBirthdays: "/driver-management/birthdays",
  birthdaySettings: "/birthday-settings",
  driverDocumentExpiries: "/driver-management/document-expiries",
  driverDocumentExpirySettings: "/driver-document-expiry-settings",
  driver: (driverId: string) => `/driver-management/${driverId}`,
  otp: "/otp-management",
  pickupBol: "/pickup-bol",
  distributionRules: "/distribution-rules",
  analytics: "/analytics",
  jobMonitoring: "/monitoring/jobs",
} as const
